import React, { useContext, useEffect, useRef, useState } from 'react'
import { Context } from '../context/Context';
import audio from '../audios/sample_audio_1.mp3'
import listeningMusic from '../assets/green/listening_music_white_bg.png'
import musicPlay from "../assets/green/play2.png";
import musicPause from "../assets/green/pause2.png";
import AudioComponent from '../commonComponents/AudioComponent';
import { useHistory } from 'react-router-dom';
import video from '../assets/videos/bayaan_video.mp4'
import playVideo from '../assets/videos/play_button.png'
import thumbnail from '../assets/videos/bayaan-thumb.png'
import './ramdan.css'
import ReactPlayer from 'react-player';
import axios from 'axios';
import { base, getHeaders } from '../Config';
import Ramadan from '../commonComponents/Ramadan';
// import listeningMusic from '../assets/green/listening_music_white_bg.png'
// import musicPlay from "../assets/green/play2.png";
// import musicPause from "../assets/green/pause2.png";



function Ramdan() {
  const { lang, theme } = useContext(Context);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false)
  const history = useHistory();
  const [videoPlay, setVideoPlay] = useState(false)
  const videoRef = useRef(null)
  const [ramadanApiData, setRamadanApiData] = useState([])
  const [ramadanVid, setRamadanVid] = useState()
  // const [ramadanSpecial, setRamadanSpecial] = useState()
  // const [ramadanDua, setRamadanDua] = useState()
  // const [ramadanNasheed, setRamadanNasheed] = useState()
  // const [ramadanRelay, setRamadanRelay] = useState()
  const [ramdanAudio, setRamadanAudio] = useState()
  const [currentPlayedAudio, setCurrentPlayedAudio] = useState()
  const { handleShowLoader } = useContext(Context)
  const [refSave , setRefSave] = useState(null)



  // find the bug in the onClickHandler function

  const refHandler = ( ref ) => {
    setVideoPlay(false)
    if(!refSave){
      setRefSave(ref)
    }else{
      refSave.current.pause()
      setRefSave(ref)
    }

  }


  const onClickHandler = (index, data, key , ref) => {

    console.log(index, data)
    setCurrentPlayedAudio(data)

    console.log("audioRef.current", audioRef.current)

    console.log("ramdanAudio[key].data[index].name", ramdanAudio[key].data[index].name)
    console.log("data.name", data.name)

    console.log("checking condition", isPlaying && data.name === ramdanAudio[key].data[index].name);


    if (isPlaying && data.name === ramdanAudio[key].data[index].name) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }

  };





  const ramdanApi = async () => {
    handleShowLoader(true)
    const response = await axios({
      url: base + "ramadan",
      method: 'post',
      headers: getHeaders()
    });

    handleShowLoader(false)

    setRamadanApiData(response.data)
    setRamadanVid(response.data?.ramadanJson?.video[0])
    setRamadanAudio(response.data?.ramadanJson?.audio)


  }

  useEffect(() => {
    ramdanApi()
  }, [])



  const onPlayFunctionVideo = (index) => {
    if(refSave){
      refSave.current.pause()
      setRefSave(null)
    }
    setVideoPlay(index)
  }



  console.log("ramadan api data", ramadanApiData)

  // setRamadanVid(ramadanApiData?.ramadanJson?.video)
  console.log("ramadanVid", ramadanVid)
  console.log("ramdanAudio", ramdanAudio)

  // setRamadanSpecial(result.data?.ramadanJson[1])
  // setRamadanDua(result.data?.ramadanJson[2])
  // setRamadanNasheed(result.data?.ramadanJson[3])
  // setRamadanRelay(result.data?.ramadanJson[4])



  return (
    <div className={`absolute pt-20 bg-green max-w-[500px] w-full min-h-screen bg-center bg-cover text-black ${theme === "red" ? "bg-red_bg_pic" : "bg-green_bg_pic"}`}>


      <div className="bg-surah_name_board mt-2 bg-50% h-12 text-white font-bold bg-center bg-no-repeat w-full py-2">
        {ramadanVid?.ramadanCategory}
      </div>

      <div className=''>
        <div className=' text-right cursor-pointer text-white' onClick={() => history.push(
          {
            pathname: "/allVideos",
            state: { allVideos: ramadanVid }
          }
        )}>Voir tout</div>
        <div className='pl-2 overflow-x-scroll py-0 flex scrollbar-hide '>

          {ramadanVid?.data?.map((data, index) => {
            return <div className='border-2 border-gray-200 ml-4 bg-[#F3F3F3] min-w-[320px] mt-1 flex justify-center p-2 rounded-lg items-center w-[80%] mx-auto'>
              <ReactPlayer
                url={data.link}
                width="100%"
                ref={videoRef}
                height="250px"
                onPlay={() => onPlayFunctionVideo(index)}
                // onPause={onPauseFunction}
                controls
                playing={videoPlay === index ? true : false}
                playIcon={<img src={playVideo} />}
                light={data.thumbnail}
              />

            </div>
          })
          }
        </div>
      </div>


      {ramdanAudio?.map((data, key) => {
        return <div>
          <div className="bg-surah_name_board mt-16 bg-50% h-12 text-white font-bold bg-center bg-no-repeat w-full py-2">
            {data?.ramadanCategory}
          </div>

          <div className=''>
            <div className=' text-right cursor-pointer text-white mr-2' onClick={() => history.push(
              {
                pathname: "/allAudios",
                state: { audioData: data }
              }
            )}>Voir tout</div>

            <div className='pl-2 overflow-x-scroll scrollbar-hide py-0 flex '>

              {/* <AudioComponent /> */}
              {/* <AudioComponent /> */}

              {data?.data?.map((data, index) => {

                return   <AudioComponent name={data?.name} link={data?.link} refHandler={refHandler} parentRef={refSave}/>

              })}

            </div>
          </div>
        </div>
      })}





    </div>
  )
}

export default Ramdan
